import { asset } from "@/lib/asset";
import React from 'react';
import DOMPurify from 'dompurify';

// Add this configuration
const sanitizeConfig = {
  ALLOWED_ATTR: ['class', 'style'] // Add other allowed attributes if needed
};

const priceData = [
    {
        image: asset("/img/icons/ph_rocket_thin.svg"), 
        title: {
            main: "Стоимость лицензии <br class='xl:hidden'/> Ключ-АСТРОМ",
            subtitle: "(включает <br class='xl:hidden'/> Единый Агент 512 Мб/час + <br class='xl:hidden'/>  Цифровой опыт 1 визит)",
            price: "2,16 Р",
            width: "xl:w-[290px]"
        },
        content: [
            "Мониторинг приложений и инфраструктуры Ключ-АСТРОМ обеспечивается путем установки Единого агента Ключ-АСТРОМ на каждый отслеживаемый хост. Единый Агент лицензируется для каждого хоста (виртуального или физического сервера).",
            "Ключ-АСТРОМ использует объем оперативной памяти на отслеживаемом сервере в качестве меры для определения размера хоста (то есть того, сколько лицензий Единого Агента он потребляет).<br/><br/>",
            "Количество необходимых единиц Цифрового опыта зависит от того, сколько пользовательских сеансов вам нужно отслеживать. Сеансы пользователей рассчитываются по каждому приложению, даже если сеанс охватывает несколько приложений из одного домена. Только пользовательские сеансы от реальных пользователей учитываются в вашем потреблении."
        ],
        width: "w-[276px] md:w-[366px] xl:w-[365px]"
    },
    {
        image: asset("/img/icons/ph_git_thin.svg"),
        title: {
            main: "Стоимость <br/> Ключ-АСТРОМ <br/> Внешние источники <br class='md:hidden'/> данных",
            subtitle: "за <br class='xl:hidden'/>  1 единицу в год",
            price: "0,22 Р",
            width: "xl:w-[333px]"
        },
        content: [
            "Ключ-АСТРОМ Внешние источники данных используются для измерения потребления средой настраиваемых показателей, строк журнала, настраиваемых событий и сторонних трассировок."
        ],
        width: "w-[198px] md:[368px] xl:w-[277px]"
    },
    {
        image: asset("/img/icons/ph_tinybit.svg"),
        title: {
            main: "Стоимость <br/> Ключ-АСТРОМ  Модуль <br/> информационной <br class='md:hidden'/> безопасности",
            subtitle: "1 <br class='hidden md:block xl:hidden'/> ед./час",
            price: "6,87 Р",
            width: "xl:w-[290px]"
        },
        content: [
            "Мониторинг состояния информационной безопасности Ключ-АСТРОМ позволяет в автоматическом режиме анализировать работу IT-ресурсов, сетевых приложений, оборудования и веб-сервисов. Искусственный интеллект платформы находит уязвимости по всему стеку в режиме реального времени. Ключ-АСТРОМ фиксирует детали по обнаруженной атаке, указывая точку входа и объект атаки, проводя при этом анализ лог файлов и кода приложения."
        ],
        width: "w-[276px] xl:w-[255px]"
    }
];

const PriceCard = ({ image, title, content, width }) => {
    return (
        <div className="w-[300px] md:w-[500px] xl:w-[255px] flex-col justify-center items-center gap-5 inline-flex mt-[51px] xl:mt-[0px]">
            
            <div className="w-[101px] h-[101px] xl:w-[142px] xl:h-[142px] xl:p-[16.89px] bg-gradient-to-br from-[#cb5e66] to-[#5e639e] rounded-[50%] xl:rounded-[90.96px] justify-center items-center gap-2 xl:gap-[7.68px] inline-flex">

                <div className="w-[77px] xl:w-[108.23px] h-[77px] xl:h-[108.23px] bg-[#c0834d] rounded-[50%] xl:rounded-[90.96px] justify-center items-center flex">
                    <img src={image}  className="w-[57px] xl:w-[80px] object-contain" />
                </div>
            </div>
             <div className="w-full xl:w-[290px] text-center">
                <div className="text-[#d8b595] text-[16px] xl:text-[20px] font-bold font-['Open Sans']">
                    <div dangerouslySetInnerHTML={{ 
                        __html: DOMPurify.sanitize(
                            title.main + (title.subtitle ? ` ${title.subtitle}` : ''),
                            sanitizeConfig
                        ) 
                    }} className={`${title.width}`}/>
                </div>
                <div className="text-2xl font-bold text-center bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text ">
                    <br/>{title.price}
                </div>
            </div>
            <div className={`w-[101px] xl:w-[365px] text-center text-[#58493b] text-base font-normal font-['Open Sans'] ${width}`}>
                {content.map((paragraph, index) => (
                    <React.Fragment key={index}>
                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(paragraph) }} className={`text-center my-[0px] py-[0]`} />
                    </React.Fragment>
                ))}
            </div>

        </div>
    );
};

const PriceStart = () => {
    return (
        <div className="w-full h-full flex flex-wrap justify-center items-center">
            <div className='w-full flex justify-center items-center mb-[40px]'>
                <div className="text-center bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text text-2xl xl:text-3xl font-bold font-['Open Sans']">
                    Цены
                </div>
            </div>

            <div className="w-full h-auto justify-center items-center inline-flex">
                <div className="flex flex-col xl:flex-row justify-center items-center xl:items-start gap-2 xl:gap-[257px]">

                    {priceData.map((price, index) => (
                        <PriceCard key={index} {...price} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PriceStart;